export default __webpack_public_path__ + "static/media/path.89d1ef9a.png";